import { Outlet } from "react-router";
import { useRefreshTokenQuery } from "../../api/auth/authApi";
import { selectCurrentToken, setCredentials } from "../../api/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoadingScreen } from "../../components/ui/LoadingScreen"; 

export const PersistLogin = () => {
    const currentToken = useSelector(selectCurrentToken);
    const dispatch = useDispatch();
    // const [skip, setSkip] = useState(() => currentToken != null)

    const { data, isLoading } = useRefreshTokenQuery(undefined, {
        // skip: skip,
    });

    if(currentToken == null && data != undefined) {

        const userState = {
            token: data.token,
            user: data.user 
        }

        dispatch(setCredentials(userState))
    }

    return (
        <>
        {isLoading
            ? <LoadingScreen />
            : <Outlet />
        }
        </>
    );

}
